// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ============================================
   FOOTER - Modern Design with Purple Branding
   ============================================ */

.footer {
  background: linear-gradient(135deg, #400C4D 0%, #2d0931 100%);
  color: #f8f9fa;
  padding: 4rem 0 0;
  margin-top: auto;
  position: relative;
  overflow: hidden;
}

/* Decorative element */
.footer::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 4px;
  background: linear-gradient(90deg, #f97316 0%, #fbbf24 50%, #f97316 100%);
}

.footer-inner {
  display: flex;
  flex-direction: column;
  gap: 0;
  max-width: 1280px;
  margin: 0 auto;
  padding: 0 2rem;
}

/* ============================================
   TOP SECTION - Brand & Main Links
   ============================================ */

.footer-top {
  display: grid;
  grid-template-columns: 1.5fr 1fr 0.8fr 1.3fr;
  gap: 3rem;
  align-items: start;
  padding-bottom: 3rem;
  border-bottom: 1px solid rgba(255, 255, 255, 0.12);
}

.footer-brand {
  display: flex;
  flex-direction: column;
  gap: 1.25rem;
}

.footer-logo {
  display: flex;
  align-items: center;
  background: white;
  padding: 0.75rem 1.25rem;
  border-radius: 12px;
  width: fit-content;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
}

.footer-logo-image {
  width: auto;
  height: 50px;
  max-width: 160px;
  object-fit: contain;
}

.footer-description {
  margin: 0;
  color: rgba(248, 249, 250, 0.85);
  line-height: 1.65;
  font-size: 0.95rem;
  max-width: 32ch;
}

/* ============================================
   COLUMN HEADINGS & LINKS
   ============================================ */

.footer-col h4 {
  margin: 0 0 1.25rem;
  font-size: 1rem;
  font-weight: 700;
  letter-spacing: 0.02em;
  color: #ffffff;
  line-height: 1.3;
  position: relative;
  padding-bottom: 0.5rem;
}

.footer-col h4::after {
  content: '';
  position: absolute;
  bottom: 0;
  left: 0;
  width: 30px;
  height: 3px;
  background: linear-gradient(90deg, #f97316 0%, #fbbf24 100%);
  border-radius: 2px;
}

.footer-links {
  list-style: none;
  padding: 0;
  margin: 0;
  display: flex;
  flex-direction: column;
  gap: 0.65rem;
}

.footer-links li {
  margin: 0;
}

.footer-links a {
  display: inline-block;
  color: rgba(248, 249, 250, 0.82);
  text-decoration: none;
  font-size: 0.9rem;
  line-height: 1.5;
  transition: all 0.2s ease;
  position: relative;
  padding-left: 0;
}

.footer-links a:hover {
  color: #fbbf24;
  padding-left: 8px;
}

/* ============================================
   CONTACT INFO
   ============================================ */

.contact-info {
  display: flex;
  flex-direction: column;
  gap: 0.85rem;
}

.contact-info p {
  margin: 0;
  font-size: 0.9rem;
  line-height: 1.65;
  color: rgba(248, 249, 250, 0.85);
}

.contact-info a {
  color: #fbbf24;
  text-decoration: none;
  font-weight: 600;
  transition: color 0.2s ease;
}

.contact-info a:hover {
  color: #f97316;
  text-decoration: underline;
}

/* Social Links */
.footer-socials {
  margin-top: 1rem;
  display: flex;
  flex-wrap: wrap;
  gap: 0.75rem;
}

.footer-socials a {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 0.5rem 1rem;
  background: rgba(255, 255, 255, 0.1);
  color: #ffffff;
  text-decoration: none;
  font-weight: 600;
  font-size: 0.85rem;
  border-radius: 8px;
  border: 1px solid rgba(255, 255, 255, 0.15);
  transition: all 0.2s ease;
  backdrop-filter: blur(10px);
}

.footer-socials a:hover {
  background: rgba(251, 191, 36, 0.15);
  border-color: #fbbf24;
  color: #fbbf24;
  transform: translateY(-2px);
}

/* ============================================
   PROGRAMS SECTION
   ============================================ */

.footer-programs {
  display: grid;
  grid-template-columns: repeat(6, 1fr);
  gap: 2.5rem 2rem;
  align-items: start;
  padding: 3rem 0;
  border-bottom: 1px solid rgba(255, 255, 255, 0.12);
}

/* ============================================
   BOTTOM SECTION
   ============================================ */

.footer-bottom {
  padding: 2rem 0;
  text-align: center;
}

.footer-bottom p {
  margin: 0;
  font-size: 0.875rem;
  color: rgba(248, 249, 250, 0.65);
  letter-spacing: 0.01em;
}

/* ============================================
   RESPONSIVE DESIGN
   ============================================ */

/* Large Tablets */
@media (max-width: 1100px) {
  .footer-top {
    grid-template-columns: repeat(2, 1fr);
    gap: 2.5rem 2rem;
  }

  .footer-programs {
    grid-template-columns: repeat(3, 1fr);
    gap: 2rem 1.5rem;
  }
}

/* Tablets */
@media (max-width: 768px) {
  .footer {
    padding: 3rem 0 0;
  }

  .footer-inner {
    padding: 0 1.5rem;
  }

  .footer-top {
    gap: 2rem 1.5rem;
  }

  .footer-programs {
    display: none;
  }

  .footer-description {
    max-width: none;
  }
}

/* Mobile */
@media (max-width: 640px) {
  .footer {
    padding: 2.5rem 0 0;
  }

  .footer-inner {
    padding: 0 1rem;
  }

  .footer-top {
    grid-template-columns: 1fr;
    gap: 2rem;
    padding-bottom: 2rem;
  }

  .footer-col h4 {
    font-size: 0.95rem;
    margin-bottom: 1rem;
  }

  .footer-logo {
    padding: 0.65rem 1rem;
  }

  .footer-logo-image {
    height: 45px;
  }

  .footer-description {
    font-size: 0.9rem;
  }

  .footer-links a {
    font-size: 0.875rem;
  }

  .contact-info p {
    font-size: 0.875rem;
  }

  .footer-socials {
    gap: 0.5rem;
  }

  .footer-socials a {
    font-size: 0.8rem;
    padding: 0.45rem 0.85rem;
  }

  .footer-bottom {
    padding: 1.5rem 0;
  }

  .footer-bottom p {
    font-size: 0.8rem;
  }
}

/* Small Mobile */
@media (max-width: 480px) {
  .footer-brand {
    gap: 1rem;
  }

  .footer-col h4 {
    font-size: 0.9rem;
  }

  .footer-links a {
    font-size: 0.85rem;
  }
}

/* ============================================
   DARK MODE SUPPORT (Optional)
   ============================================ */

html[data-theme="dark"] .footer {
  background: linear-gradient(135deg, #1a0a1d 0%, #0f0713 100%);
}

html[data-theme="dark"] .footer-logo {
  background: rgba(255, 255, 255, 0.95);
}
`, "",{"version":3,"sources":["webpack://./src/frontend/components/Footer/footer.css"],"names":[],"mappings":"AAAA;;iDAEiD;;AAEjD;EACE,6DAA6D;EAC7D,cAAc;EACd,iBAAiB;EACjB,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA,uBAAuB;AACvB;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,QAAQ;EACR,WAAW;EACX,yEAAyE;AAC3E;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,MAAM;EACN,iBAAiB;EACjB,cAAc;EACd,eAAe;AACjB;;AAEA;;iDAEiD;;AAEjD;EACE,aAAa;EACb,4CAA4C;EAC5C,SAAS;EACT,kBAAkB;EAClB,oBAAoB;EACpB,kDAAkD;AACpD;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,iBAAiB;EACjB,wBAAwB;EACxB,mBAAmB;EACnB,kBAAkB;EAClB,0CAA0C;AAC5C;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,SAAS;EACT,gCAAgC;EAChC,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;;iDAEiD;;AAEjD;EACE,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,cAAc;EACd,gBAAgB;EAChB,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,SAAS;EACT,OAAO;EACP,WAAW;EACX,WAAW;EACX,4DAA4D;EAC5D,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,UAAU;EACV,SAAS;EACT,aAAa;EACb,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,qBAAqB;EACrB,gCAAgC;EAChC,qBAAqB;EACrB,iBAAiB;EACjB,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,iBAAiB;AACnB;;AAEA;;iDAEiD;;AAEjD;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,SAAS;EACT,iBAAiB;EACjB,iBAAiB;EACjB,gCAAgC;AAClC;;AAEA;EACE,cAAc;EACd,qBAAqB;EACrB,gBAAgB;EAChB,2BAA2B;AAC7B;;AAEA;EACE,cAAc;EACd,0BAA0B;AAC5B;;AAEA,iBAAiB;AACjB;EACE,gBAAgB;EAChB,aAAa;EACb,eAAe;EACf,YAAY;AACd;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,oBAAoB;EACpB,oCAAoC;EACpC,cAAc;EACd,qBAAqB;EACrB,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;EAClB,2CAA2C;EAC3C,yBAAyB;EACzB,2BAA2B;AAC7B;;AAEA;EACE,oCAAoC;EACpC,qBAAqB;EACrB,cAAc;EACd,2BAA2B;AAC7B;;AAEA;;iDAEiD;;AAEjD;EACE,aAAa;EACb,qCAAqC;EACrC,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,kDAAkD;AACpD;;AAEA;;iDAEiD;;AAEjD;EACE,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,SAAS;EACT,mBAAmB;EACnB,gCAAgC;EAChC,sBAAsB;AACxB;;AAEA;;iDAEiD;;AAEjD,kBAAkB;AAClB;EACE;IACE,qCAAqC;IACrC,gBAAgB;EAClB;;EAEA;IACE,qCAAqC;IACrC,gBAAgB;EAClB;AACF;;AAEA,YAAY;AACZ;EACE;IACE,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,eAAe;EACjB;AACF;;AAEA,WAAW;AACX;EACE;IACE,mBAAmB;EACrB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,0BAA0B;IAC1B,SAAS;IACT,oBAAoB;EACtB;;EAEA;IACE,kBAAkB;IAClB,mBAAmB;EACrB;;EAEA;IACE,qBAAqB;EACvB;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,iBAAiB;IACjB,wBAAwB;EAC1B;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;EACnB;AACF;;AAEA,iBAAiB;AACjB;EACE;IACE,SAAS;EACX;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,kBAAkB;EACpB;AACF;;AAEA;;iDAEiD;;AAEjD;EACE,6DAA6D;AAC/D;;AAEA;EACE,qCAAqC;AACvC","sourcesContent":["/* ============================================\n   FOOTER - Modern Design with Purple Branding\n   ============================================ */\n\n.footer {\n  background: linear-gradient(135deg, #400C4D 0%, #2d0931 100%);\n  color: #f8f9fa;\n  padding: 4rem 0 0;\n  margin-top: auto;\n  position: relative;\n  overflow: hidden;\n}\n\n/* Decorative element */\n.footer::before {\n  content: '';\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  height: 4px;\n  background: linear-gradient(90deg, #f97316 0%, #fbbf24 50%, #f97316 100%);\n}\n\n.footer-inner {\n  display: flex;\n  flex-direction: column;\n  gap: 0;\n  max-width: 1280px;\n  margin: 0 auto;\n  padding: 0 2rem;\n}\n\n/* ============================================\n   TOP SECTION - Brand & Main Links\n   ============================================ */\n\n.footer-top {\n  display: grid;\n  grid-template-columns: 1.5fr 1fr 0.8fr 1.3fr;\n  gap: 3rem;\n  align-items: start;\n  padding-bottom: 3rem;\n  border-bottom: 1px solid rgba(255, 255, 255, 0.12);\n}\n\n.footer-brand {\n  display: flex;\n  flex-direction: column;\n  gap: 1.25rem;\n}\n\n.footer-logo {\n  display: flex;\n  align-items: center;\n  background: white;\n  padding: 0.75rem 1.25rem;\n  border-radius: 12px;\n  width: fit-content;\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);\n}\n\n.footer-logo-image {\n  width: auto;\n  height: 50px;\n  max-width: 160px;\n  object-fit: contain;\n}\n\n.footer-description {\n  margin: 0;\n  color: rgba(248, 249, 250, 0.85);\n  line-height: 1.65;\n  font-size: 0.95rem;\n  max-width: 32ch;\n}\n\n/* ============================================\n   COLUMN HEADINGS & LINKS\n   ============================================ */\n\n.footer-col h4 {\n  margin: 0 0 1.25rem;\n  font-size: 1rem;\n  font-weight: 700;\n  letter-spacing: 0.02em;\n  color: #ffffff;\n  line-height: 1.3;\n  position: relative;\n  padding-bottom: 0.5rem;\n}\n\n.footer-col h4::after {\n  content: '';\n  position: absolute;\n  bottom: 0;\n  left: 0;\n  width: 30px;\n  height: 3px;\n  background: linear-gradient(90deg, #f97316 0%, #fbbf24 100%);\n  border-radius: 2px;\n}\n\n.footer-links {\n  list-style: none;\n  padding: 0;\n  margin: 0;\n  display: flex;\n  flex-direction: column;\n  gap: 0.65rem;\n}\n\n.footer-links li {\n  margin: 0;\n}\n\n.footer-links a {\n  display: inline-block;\n  color: rgba(248, 249, 250, 0.82);\n  text-decoration: none;\n  font-size: 0.9rem;\n  line-height: 1.5;\n  transition: all 0.2s ease;\n  position: relative;\n  padding-left: 0;\n}\n\n.footer-links a:hover {\n  color: #fbbf24;\n  padding-left: 8px;\n}\n\n/* ============================================\n   CONTACT INFO\n   ============================================ */\n\n.contact-info {\n  display: flex;\n  flex-direction: column;\n  gap: 0.85rem;\n}\n\n.contact-info p {\n  margin: 0;\n  font-size: 0.9rem;\n  line-height: 1.65;\n  color: rgba(248, 249, 250, 0.85);\n}\n\n.contact-info a {\n  color: #fbbf24;\n  text-decoration: none;\n  font-weight: 600;\n  transition: color 0.2s ease;\n}\n\n.contact-info a:hover {\n  color: #f97316;\n  text-decoration: underline;\n}\n\n/* Social Links */\n.footer-socials {\n  margin-top: 1rem;\n  display: flex;\n  flex-wrap: wrap;\n  gap: 0.75rem;\n}\n\n.footer-socials a {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  padding: 0.5rem 1rem;\n  background: rgba(255, 255, 255, 0.1);\n  color: #ffffff;\n  text-decoration: none;\n  font-weight: 600;\n  font-size: 0.85rem;\n  border-radius: 8px;\n  border: 1px solid rgba(255, 255, 255, 0.15);\n  transition: all 0.2s ease;\n  backdrop-filter: blur(10px);\n}\n\n.footer-socials a:hover {\n  background: rgba(251, 191, 36, 0.15);\n  border-color: #fbbf24;\n  color: #fbbf24;\n  transform: translateY(-2px);\n}\n\n/* ============================================\n   PROGRAMS SECTION\n   ============================================ */\n\n.footer-programs {\n  display: grid;\n  grid-template-columns: repeat(6, 1fr);\n  gap: 2.5rem 2rem;\n  align-items: start;\n  padding: 3rem 0;\n  border-bottom: 1px solid rgba(255, 255, 255, 0.12);\n}\n\n/* ============================================\n   BOTTOM SECTION\n   ============================================ */\n\n.footer-bottom {\n  padding: 2rem 0;\n  text-align: center;\n}\n\n.footer-bottom p {\n  margin: 0;\n  font-size: 0.875rem;\n  color: rgba(248, 249, 250, 0.65);\n  letter-spacing: 0.01em;\n}\n\n/* ============================================\n   RESPONSIVE DESIGN\n   ============================================ */\n\n/* Large Tablets */\n@media (max-width: 1100px) {\n  .footer-top {\n    grid-template-columns: repeat(2, 1fr);\n    gap: 2.5rem 2rem;\n  }\n\n  .footer-programs {\n    grid-template-columns: repeat(3, 1fr);\n    gap: 2rem 1.5rem;\n  }\n}\n\n/* Tablets */\n@media (max-width: 768px) {\n  .footer {\n    padding: 3rem 0 0;\n  }\n\n  .footer-inner {\n    padding: 0 1.5rem;\n  }\n\n  .footer-top {\n    gap: 2rem 1.5rem;\n  }\n\n  .footer-programs {\n    display: none;\n  }\n\n  .footer-description {\n    max-width: none;\n  }\n}\n\n/* Mobile */\n@media (max-width: 640px) {\n  .footer {\n    padding: 2.5rem 0 0;\n  }\n\n  .footer-inner {\n    padding: 0 1rem;\n  }\n\n  .footer-top {\n    grid-template-columns: 1fr;\n    gap: 2rem;\n    padding-bottom: 2rem;\n  }\n\n  .footer-col h4 {\n    font-size: 0.95rem;\n    margin-bottom: 1rem;\n  }\n\n  .footer-logo {\n    padding: 0.65rem 1rem;\n  }\n\n  .footer-logo-image {\n    height: 45px;\n  }\n\n  .footer-description {\n    font-size: 0.9rem;\n  }\n\n  .footer-links a {\n    font-size: 0.875rem;\n  }\n\n  .contact-info p {\n    font-size: 0.875rem;\n  }\n\n  .footer-socials {\n    gap: 0.5rem;\n  }\n\n  .footer-socials a {\n    font-size: 0.8rem;\n    padding: 0.45rem 0.85rem;\n  }\n\n  .footer-bottom {\n    padding: 1.5rem 0;\n  }\n\n  .footer-bottom p {\n    font-size: 0.8rem;\n  }\n}\n\n/* Small Mobile */\n@media (max-width: 480px) {\n  .footer-brand {\n    gap: 1rem;\n  }\n\n  .footer-col h4 {\n    font-size: 0.9rem;\n  }\n\n  .footer-links a {\n    font-size: 0.85rem;\n  }\n}\n\n/* ============================================\n   DARK MODE SUPPORT (Optional)\n   ============================================ */\n\nhtml[data-theme=\"dark\"] .footer {\n  background: linear-gradient(135deg, #1a0a1d 0%, #0f0713 100%);\n}\n\nhtml[data-theme=\"dark\"] .footer-logo {\n  background: rgba(255, 255, 255, 0.95);\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
